import Nullstack from 'nullstack';
export default function IconDrone({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-drone",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10 10h4v4h-4z"
  }), "   ", Nullstack.element("line", {
    x1: "10",
    y1: "10",
    x2: "6.5",
    y2: "6.5"
  }), "   ", Nullstack.element("path", {
    d: "M9.96 6a3.5 3.5 0 1 0 -3.96 3.96"
  }), "   ", Nullstack.element("path", {
    d: "M14 10l3.5 -3.5"
  }), "   ", Nullstack.element("path", {
    d: "M18 9.96a3.5 3.5 0 1 0 -3.96 -3.96"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "14",
    x2: "17.5",
    y2: "17.5"
  }), "   ", Nullstack.element("path", {
    d: "M14.04 18a3.5 3.5 0 1 0 3.96 -3.96"
  }), "   ", Nullstack.element("line", {
    x1: "10",
    y1: "14",
    x2: "6.5",
    y2: "17.5"
  }), "   ", Nullstack.element("path", {
    d: "M6 14.04a3.5 3.5 0 1 0 3.96 3.96"
  }), " ");
}